// Authentication storage keys
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  REMEMBER_ME: 'remember_me',
  ORGANIZATION_ID: 'organization_id',
} as const;

// API endpoints
export const API_ENDPOINTS = {
  LOGIN: '/auth/login/',
  REGISTER: '/auth/register/',
  LOGOUT: '/auth/logout/',
  REFRESH: '/auth/refresh/',
  VERIFY_EMAIL: '/auth/register/verify-email/code/',
  RESEND_EMAIL: '/auth/register/resend-email/',
  CHANGE_PASSWORD: '/auth/password/change/',
  PASSWORD_RESET: '/auth/password/reset/',
  PASSWORD_RESET_CONFIRM: '/auth/password/reset/confirm/',
  CREATE_ORGANIZATION: '/auth/organization/create/',
  COMPLETE_REGISTRATION_PAYMENT: '/billing/registration/payment/',
  SEPA_MANDATE: '/billing/sepa-mandate/',
  PLANS: '/billing/plans/',
  CURRENT_USER: '/users/current-user/',
} as const;

// HTTP headers
export const HTTP_HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  AUTHORIZATION: 'Authorization',
  ORGANIZATION_ID: 'X-Organization-ID',
} as const;

// Content types
export const CONTENT_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
} as const;
